// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"9020f90fa10ad2e9","308":"748b8af06e852538"}[chunkId] + ".css";
};